export enum GemFeature {
  COLOR = 'color',
  SECONDARY_COLOR = 'secondary color',
  SPECIES = 'species',
  CLARITY = 'clarity',
  CUT = 'cut',
  SHAPE = 'shape',
  ORIGIN = 'origin',
  CERTIFICATE = 'gem Lab',
  TREATMENT = 'treatment',
  COLOR_SPECIAL_DESCRIPTORS = 'color special descriptors',
  INTENSITY = 'intensity',
}

export enum GemFeatureCode {
  COLOR = 'color',
  SECONDARY_COLOR = 'secondaryColor',
  SPECIES = 'species',
  CLARITY = 'clarity',
  CUT = 'cut',
  SHAPE = 'shape',
  ORIGIN = 'origin',
  CERTIFICATE = 'certificate',
  TREATMENT = 'treatment',
  COLOR_SPECIAL_DESCRIPTORS = 'specialDescriptor',
  INTENSITY = 'intensity',
}
